/**
 * Formats a YYYY-MM-DD or YYYY/MM/DD arrival date as `Mon, August 11` (en)
 * or the French-Canada equivalent for the Review estimate heading.
 *
 * @param deliveryDate Arrival date from the selected service
 * @param locale Active UI locale
 */
export function formatReviewArrivalDate(deliveryDate: string, locale: 'en' | 'fr'): string {
  const normalized = deliveryDate.replaceAll('-', '/');
  const [year, month, day] = normalized.split('/').map((part) => Number.parseInt(part, 10));
  if (!year || !month || !day) {
    return deliveryDate;
  }

  const date = new Date(Date.UTC(year, month - 1, day));
  return new Intl.DateTimeFormat(locale === 'fr' ? 'fr-CA' : 'en-CA', {
    weekday: 'short',
    month: 'long',
    day: 'numeric',
    timeZone: 'UTC',
  }).format(date);
}
